import { InputFieldLabel } from '../../../../lib/components/atomic/input/shared/fieldLabel';
import { DatePicker } from '../../../../lib/components';
import { useTranslation } from 'react-i18next';
import { useFormikContext, FormikValues } from 'formik';

interface PayoutMonthProps {
  disabled?: boolean;
  minDate?: Date;
  maxDate?: Date;
}

export const PayoutMonth = ({ disabled, minDate, maxDate }: PayoutMonthProps) => {
  const { t } = useTranslation();
  const { values, touched, errors, setFieldValue } = useFormikContext<FormikValues>();

  return (
    <div className="w-full">
      <InputFieldLabel
        label={t('bonus:payoutMonth')}
        required
        tooltip={t('bonus:tooltip:payoutMonth')}
        disabled={disabled}
      />
      <DatePicker
        variant="month"
        initialValue={values.payoutMonth?.toString()}
        placeholder={t('bonus:selectPayoutMonth')}
        required
        disabled={disabled}
        minDate={minDate}
        maxDate={maxDate}
        error={touched.payoutMonth && !!errors.payoutMonth}
        helperText={(touched.payoutMonth && errors.payoutMonth) as string}
        onChange={(date) => {
          setFieldValue('payoutMonth', new Date(date));
        }}
      />
    </div>
  );
};
